/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OnlyFansLinkType {
    NO_LINK = 'NO_LINK',
    DIRECT = 'DIRECT',
    EXTERNAL = 'EXTERNAL',
}
